import { CookieManager } from './cookieManager';

const CUSTOM_ELEMENT_NAME = 'wix-referrals-cookie-manager';

customElements.define(CUSTOM_ELEMENT_NAME, CookieManager);
